import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import CRMLogo from 'assets/images/crm-logo.png';
import styles from './index.less';

const cx = classNames.bind(styles);

const propTypes = {
  backgroundSrc: PropTypes.string,
  children: PropTypes.element.isRequired,
};

const defaultProps = {
  backgroundSrc: '',
};

const AuthWrapper = ({
  children,
  backgroundSrc
}) => (
  <div className={cx('auth-wrapper', backgroundSrc ? 'auth-wrapper-bg' : '')} style={{ backgroundImage: `url(${backgroundSrc})` }}>
    <div className={cx('auth-wrapper-logo')}>
      <img src={CRMLogo} alt="logo" />
    </div>
    <div>
      {children}
    </div>
  </div>
);

AuthWrapper.propTypes = propTypes;
AuthWrapper.defaultProps = defaultProps;

export default AuthWrapper;



// WEBPACK FOOTER //
// ./src/components/ui/AuthWrapper/index.jsx